import React from "react";
import NextImage, { ImageProps } from "../../../node_modules/next/image";

export * from "../../../node_modules/next/image";

const Image = (props: ImageProps) => {
  return (
    <NextImage
      {...props}
      data-ot-ignore=""
      className={`optanon-category-C0001 ${props.className || ""}`}
    />
  );
};

export default Image;
